"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var clsx_1 = __importDefault(require("clsx"));
var react_i18next_1 = require("react-i18next");
var ui_1 = require("@aperza/ui");
var ac_ui_1 = require("@aperza/ac-ui");
var Carousel_1 = __importDefault(require("../../ui/Carousel"));
var ReadMore_1 = require("../../ui/ReadMore");
var BrandLogo_1 = __importDefault(require("../../ui/BrandLogo"));
var CatalogPreview_module_scss_1 = __importDefault(require("./CatalogPreview.module.scss"));
var react_slick_1 = __importDefault(require("react-slick"));
var TdWebService_1 = require("../../../service/TdWebService");
var CatalogPreview = function (props) {
    var _a = props.catalog, catalog = _a === void 0 ? {} : _a;
    var companyContractDisplayId = catalog.companyContractDisplayId, companyId = catalog.companyId, catalogId = catalog.catalogId, documentId = catalog.documentId, designType = catalog.designType;
    var windowWidth = ui_1.useWindowResize().windowWidth;
    var t = react_i18next_1.useTranslation(['catalog']).t;
    var sendMessage = ui_1.useReactiveMessage('CATALOG_DOWNLOAD_CLUEZ').sendMessage;
    var blockButton = function (width) {
        return width <= 769;
    };
    var onClickDownload = function () {
        sendMessage({
            companyContractDisplayId: companyContractDisplayId,
            companyId: companyId,
            catalogId: catalogId,
            documentId: documentId,
            catalogPreview: true,
        });
    };
    var renderCatalogPage = function (catalog) {
        var title = catalog.title, subtitle = catalog.subtitle, description = catalog.description, brandImageUrl = catalog.brandImageUrl, brandName = catalog.brandName, companyPageUrl = catalog.companyPageUrl, type = catalog.type, fileSize = catalog.fileSize, makerItemCompanyUrl = catalog.makerItemCompanyUrl, makerItemCompanyName = catalog.makerItemCompanyName, makerItemCompanyLogoUrl = catalog.makerItemCompanyLogoUrl, documentPreviewUrl = catalog.documentPreviewUrl, documentPublishFlag = catalog.documentPublishFlag, isSharedDocument = catalog.isSharedDocument, isReferencedDocument = catalog.isReferencedDocument, itemCompanyContractDisplayId = catalog.itemCompanyContractDisplayId, documentDisplayId = catalog.documentDisplayId, documentType = catalog.documentType, makerItemCompanyContractDisplayId = catalog.makerItemCompanyContractDisplayId, makerItemDocumentDisplayId = catalog.makerItemDocumentDisplayId, cluezCategoryIdPath = catalog.cluezCategoryIdPath, userId = catalog.userId, companyName = catalog.companyName, catalogPageUrl = catalog.catalogPageUrl, companyContractDisplayId = catalog.companyContractDisplayId, companyId = catalog.companyId, catalogId = catalog.catalogId, documentId = catalog.documentId, _a = catalog.pages, pages = _a === void 0 ? [] : _a;
        var onClickCatalogPreview = function () {
            console.log('onClickCatalogPreview() in renderCatalogPage()');
            TdWebService_1.TdWebService.setMemberId(userId);
            TdWebService_1.TdWebService.clickCatalogViewer({
                click_url: documentPreviewUrl,
                ev_company_type: 10,
                ev_company_id: itemCompanyContractDisplayId,
                ev_company_name: companyName,
                ev_catalog_id: catalogId,
                ev_catalog_category_id: cluezCategoryIdPath,
                ev_document_id: documentDisplayId,
                ev_document_type: documentType,
                ev_company_id_origin: makerItemCompanyContractDisplayId,
                ev_catalog_id_origin: makerItemDocumentDisplayId,
            });
        };
        return (react_1.default.createElement("div", { className: "container-fluid" },
            react_1.default.createElement("div", { className: "row" },
                react_1.default.createElement("div", { className: "col-md-6 mb-3 p-0" },
                    react_1.default.createElement(Carousel_1.default, { items: pages })),
                react_1.default.createElement("div", { className: clsx_1.default('col-md-6', CatalogPreview_module_scss_1.default.CatalogDesc) },
                    react_1.default.createElement("h4", { className: "ttl fs-2 mb-3 font-weight-bold", id: "previewCatalogTitle" }, title),
                    isSharedDocument && (react_1.default.createElement("div", { className: clsx_1.default('mb-3', CatalogPreview_module_scss_1.default.CatalogPreviewCompanyInfo) }, makerItemCompanyName)),
                    !isSharedDocument && (react_1.default.createElement("div", { className: clsx_1.default('mb-3', CatalogPreview_module_scss_1.default.CatalogPreviewCompanyInfo) },
                        react_1.default.createElement(BrandLogo_1.default, { name: brandName, imageUrl: brandImageUrl, pageUrl: companyPageUrl }))),
                    react_1.default.createElement("div", { className: "mb-3", id: "previewCatalogType" },
                        react_1.default.createElement(ui_1.Tag, { name: type })),
                    react_1.default.createElement("div", { className: "txt font-weight-bold mb-3", id: "previewCatalogSubtitle" }, subtitle),
                    react_1.default.createElement("div", { className: "mb-3 preview-description" },
                        react_1.default.createElement(ReadMore_1.ReadMore, { text: description, line: 4, more: t('catalog.preview.more'), less: t('catalog.preview.less') })),
                    react_1.default.createElement("div", { className: "btn-wrap" },
                        documentPreviewUrl != null &&
                            documentPreviewUrl !== undefined &&
                            documentPreviewUrl !== '' &&
                            (isReferencedDocument ||
                                (documentPublishFlag != null &&
                                    documentPublishFlag !== undefined &&
                                    documentPublishFlag == 2)) && (react_1.default.createElement("a", { href: documentPreviewUrl, className: clsx_1.default('btn btn-download btn-xl text-wrap', CatalogPreview_module_scss_1.default.CatalogRowCardButton), onClick: onClickCatalogPreview, target: "_blank" },
                            react_1.default.createElement("i", { className: "fa fa-download fa-fw" }),
                            t('download'),
                            react_1.default.createElement("small", { className: "ml-2" },
                                "(",
                                react_1.default.createElement(ui_1.FileSize, { documentSizeBytes: fileSize }),
                                ")"))),
                        !isReferencedDocument &&
                            (documentPublishFlag == null ||
                                documentPublishFlag === undefined ||
                                documentPublishFlag != 2) && (react_1.default.createElement(ui_1.DownloadButton, { variant: 'download', size: fileSize, block: blockButton(windowWidth), onClick: onClickDownload })),
                        !isSharedDocument && (react_1.default.createElement(ui_1.LinkButton, { variant: 'default', label: t('catalog.preview.page'), href: catalogPageUrl, block: blockButton(windowWidth) })))))));
    };
    var renderCustomPage = function (catalog) {
        var title = catalog.title, subtitle = catalog.subtitle, description = catalog.description, brandImageUrl = catalog.brandImageUrl, brandName = catalog.brandName, companyPageUrl = catalog.companyPageUrl, type = catalog.type, fileSize = catalog.fileSize, makerItemCompanyUrl = catalog.makerItemCompanyUrl, makerItemCompanyName = catalog.makerItemCompanyName, makerItemCompanyLogoUrl = catalog.makerItemCompanyLogoUrl, documentPreviewUrl = catalog.documentPreviewUrl, documentPublishFlag = catalog.documentPublishFlag, isSharedDocument = catalog.isSharedDocument, isReferencedDocument = catalog.isReferencedDocument, itemCompanyContractDisplayId = catalog.itemCompanyContractDisplayId, documentDisplayId = catalog.documentDisplayId, documentType = catalog.documentType, makerItemCompanyContractDisplayId = catalog.makerItemCompanyContractDisplayId, makerItemDocumentDisplayId = catalog.makerItemDocumentDisplayId, cluezCategoryIdPath = catalog.cluezCategoryIdPath, userId = catalog.userId, companyName = catalog.companyName, catalogPageUrl = catalog.catalogPageUrl, companyContractDisplayId = catalog.companyContractDisplayId, companyId = catalog.companyId, catalogId = catalog.catalogId, documentId = catalog.documentId, _a = catalog.pages, pages = _a === void 0 ? [] : _a;
        var CarouselPrevArrow = function (carouselProps) {
            var onClick = carouselProps.onClick;
            return (react_1.default.createElement("button", { type: "button", className: "position-absolute border-0 bg-transparent slick-custom-arrow slick-custom-prev", onClick: onClick },
                react_1.default.createElement("i", { className: "far fa-chevron-left text-white" })));
        };
        var CarouselNextArrow = function (carouselProps) {
            var onClick = carouselProps.onClick;
            return (react_1.default.createElement("button", { type: "button", className: "position-absolute border-0 bg-transparent slick-custom-arrow slick-custom-next", onClick: onClick },
                react_1.default.createElement("i", { className: "far fa-chevron-right text-white" })));
        };
        var settings = {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: react_1.default.createElement(CarouselPrevArrow, null),
            nextArrow: react_1.default.createElement(CarouselNextArrow, null),
            adaptiveHeight: false,
            autoplay: true,
        };
        var renderImages = function (items) {
            if (items === void 0) { items = []; }
            return items.map(function (item, index) {
                return (react_1.default.createElement("div", { key: index },
                    react_1.default.createElement("img", { className: "img img-fluid", src: item.imageUrl, height: "370" })));
            });
        };
        var buttonStyle = {
            textAlign: 'center',
        };
        var onClickCatalogPreview = function () {
            console.log('onClickCatalogPreview() in renderCustomPage()');
            TdWebService_1.TdWebService.setMemberId(userId);
            TdWebService_1.TdWebService.clickCatalogViewer({
                click_url: documentPreviewUrl,
                ev_company_type: 10,
                ev_company_id: itemCompanyContractDisplayId,
                ev_company_name: companyName,
                ev_catalog_id: catalogId,
                ev_catalog_category_id: cluezCategoryIdPath,
                ev_document_id: documentDisplayId,
                ev_document_type: documentType,
                ev_company_id_origin: makerItemCompanyContractDisplayId,
                ev_catalog_id_origin: makerItemDocumentDisplayId,
            });
        };
        // @ts-ignore
        return (react_1.default.createElement("div", { className: "container-fluid" },
            react_1.default.createElement("div", { className: "row" },
                react_1.default.createElement("div", { className: "col-md-6 mb-3 p-0" },
                    react_1.default.createElement(react_slick_1.default, __assign({}, settings), renderImages(pages))),
                react_1.default.createElement("div", { className: "col-md-6" },
                    react_1.default.createElement("h4", { className: "fs-20 text-dark mb-2 font-weight-bold", id: "previewCatalogTitle" }, title),
                    !isSharedDocument && (react_1.default.createElement("div", { className: "mb-2 d-flex align-items-center" },
                        react_1.default.createElement("div", { className: "border mr-2 p-1 d-flex align-items-center justify-content-center", style: { width: '45px', height: '45px' } },
                            react_1.default.createElement("img", { className: "img-fluid", src: brandImageUrl })),
                        react_1.default.createElement("a", { href: companyPageUrl },
                            react_1.default.createElement("span", { className: "cap", id: "previewCatalogCompanyName" }, brandName)))),
                    isSharedDocument && (react_1.default.createElement("div", { className: clsx_1.default('mb-3', CatalogPreview_module_scss_1.default.CatalogPreviewCompanyInfo) }, makerItemCompanyName)),
                    react_1.default.createElement("div", { className: "mb-2" },
                        react_1.default.createElement(ui_1.Tag, { name: type })),
                    react_1.default.createElement("div", { className: "txt font-weight-bold mb-3", id: "previewCatalogSubtitle" }, subtitle),
                    react_1.default.createElement("div", { className: "mb-3 preview-description" },
                        react_1.default.createElement(ReadMore_1.ReadMore, { text: description, line: 4, more: t('catalog.preview.more'), less: t('catalog.preview.less') })),
                    react_1.default.createElement("div", { className: "btn-wrap", style: buttonStyle },
                        documentPreviewUrl != null &&
                            documentPreviewUrl !== undefined &&
                            documentPreviewUrl !== '' &&
                            (isReferencedDocument ||
                                (documentPublishFlag != null &&
                                    documentPublishFlag !== undefined &&
                                    documentPublishFlag == 2)) && (react_1.default.createElement(ac_ui_1.AcButton, { variant: 'warning', className: 'mr-2 mb-2', href: documentPreviewUrl, block: blockButton(windowWidth), onClick: onClickCatalogPreview },
                            react_1.default.createElement("i", { className: "fa fa-download fa-fw" }),
                            react_1.default.createElement("span", { className: "ml-2" }, t('download')),
                            react_1.default.createElement("small", { className: "ml-2" },
                                "(",
                                react_1.default.createElement(ui_1.FileSize, { documentSizeBytes: fileSize }),
                                ")"))),
                        !isReferencedDocument &&
                            (documentPublishFlag == null ||
                                documentPublishFlag === undefined ||
                                documentPublishFlag != 2) && (react_1.default.createElement(ac_ui_1.AcButton, { variant: 'warning', className: 'mr-2 mb-2', onClick: onClickDownload, block: blockButton(windowWidth) },
                            react_1.default.createElement("i", { className: "fa fa-download fa-fw" }),
                            react_1.default.createElement("span", { className: "ml-2" }, t('download')),
                            react_1.default.createElement("small", { className: "ml-2" },
                                "(",
                                react_1.default.createElement(ui_1.FileSize, { documentSizeBytes: fileSize }),
                                ")"))),
                        !isSharedDocument && (react_1.default.createElement(ac_ui_1.AcButton, { variant: 'outline-primary', className: 'mr-2 mb-2', href: catalogPageUrl, block: blockButton(windowWidth) },
                            react_1.default.createElement("span", { className: "ml-2" }, t('catalog.preview.page')))))))));
    };
    return designType === 'CustomPage' ? renderCustomPage(catalog) : renderCatalogPage(catalog);
};
CatalogPreview.propTypes = {
    catalog: prop_types_1.default.shape({
        title: prop_types_1.default.string,
        subtitle: prop_types_1.default.string,
        description: prop_types_1.default.string,
        type: prop_types_1.default.string,
        brandName: prop_types_1.default.string,
        brandImageUrl: prop_types_1.default.string,
        fileSize: prop_types_1.default.string,
        isReferencedDocument: prop_types_1.default.bool,
        catalogPageUrl: prop_types_1.default.string,
        companyContractDisplayId: prop_types_1.default.number,
        companyId: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
        catalogId: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
        pages: prop_types_1.default.arrayOf(prop_types_1.default.shape({
            name: prop_types_1.default.string,
            imageUrl: prop_types_1.default.string,
        })),
        designType: prop_types_1.default.string,
    }),
};
exports.default = CatalogPreview;
